import {z} from "zod/v4-mini"
import * as legacyZod from "zod"

export const textureStreamingMode = z.enum(["off", "low-quality", "high-quality", "ultra-quality"])
export const legacyTextureStreamingMode = legacyZod.enum(["off", "low-quality", "high-quality", "ultra-quality"])
export type TextureStreamingMode = z.infer<typeof textureStreamingMode>
